import { BusinessAddress, BusinessAddressType } from '@/models/businesses/business-address';
import { GenericResult } from '@/models/common/results/generic-result';
import { axiosService } from '.';

export default class BusinessAddressesService {
    public async newBusinessAddress(businessId: number, businessAddress: BusinessAddress): Promise<GenericResult> {
        return new GenericResult((await axiosService.instance.post(`businesses/organization/addresses/${businessId}/new`, businessAddress)).data);
    }

    public async getBusinessAddress(businessId: number, type: BusinessAddressType): Promise<BusinessAddress> {
        return new BusinessAddress((await axiosService.instance.get(`businesses/organization/addresses/${businessId}/${BusinessAddressType[type]}`)).data);
    }

    public async updateBusinessAddress(businessId: number, businessAddress: BusinessAddress): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/addresses/${businessId}/update`, businessAddress)).data;
    }
}

export const businessAddressesService = new BusinessAddressesService();
